import { Instagram, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const HANDLE = "talkbyrajdeep";
const PROFILE = "https://www.instagram.com/talkbyrajdeep/";

const TILES = [
  { src: "/images/ig-1.jpg", alt: "A kintsugi-mended teacup on ivory linen with olive leaves" },
  { src: "/images/ig-2.jpg", alt: "A brass sconce and dried eucalyptus on a deep maroon wall" },
  { src: "/images/ig-3.jpg", alt: "A fountain pen and brass paperweight on cream handmade paper" },
  { src: "/images/ig-4.jpg", alt: "A cream linen armchair in a sunlit ivory room" },
  { src: "/images/ig-5.jpg", alt: "Dried pampas in a burgundy stoneware vase on marble" },
  { src: "/images/ig-6.jpg", alt: "A ceramic dish being mended with gold lacquer" },
];

export default function InstagramStrip() {
  return (
    <section className="relative py-24 md:py-32" data-testid="instagram-section">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
            <div>
              <p className="eyebrow mb-6">Latest from the studio</p>
              <h2 className="font-display text-ink font-medium leading-[1.1] text-4xl sm:text-5xl" data-testid="instagram-heading">
                @{HANDLE}
              </h2>
            </div>
            <a
              href={PROFILE}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-follow-button"
              className="inline-flex items-center gap-2 self-start bg-deep text-canvas text-[11px] uppercase tracking-[0.24em] px-7 py-3.5 hover:bg-gold transition-colors duration-300"
            >
              <Instagram size={15} strokeWidth={1.6} /> Follow on Instagram
            </a>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {TILES.map((t, i) => (
            <Reveal key={t.src} delay={i * 0.05}>
              <a
                href={PROFILE}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`instagram-tile-${i}`}
                className="group relative block overflow-hidden border border-[rgba(169,129,47,0.26)] hover:border-gold transition-colors duration-500"
              >
                <img
                  src={t.src}
                  alt={t.alt}
                  loading="lazy"
                  className="w-full aspect-square object-cover group-hover:scale-[1.06] transition-transform duration-[1200ms] ease-out"
                />
                <span className="absolute inset-0 flex items-center justify-center bg-deep/0 group-hover:bg-deep/45 transition-colors duration-500">
                  <ArrowUpRight
                    size={22}
                    strokeWidth={1.4}
                    className="text-canvas opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
